<template>
  <v-dialog v-model="showDialog" :max-width="maxWidth">
    <v-card>
      <v-toolbar flat color="primary">
        <v-toolbar-title class="font-weight-medium">
          {{ title }}
        </v-toolbar-title>
        <v-spacer />
        <v-btn icon @click="$emit('update:modelValue', false)">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text class="pt-6 px-4" style="font-size: 1rem">
        <slot />
      </v-card-text>
      <v-divider />
      <v-card-actions v-show="!hideActions">
        <v-btn class="cancel" variant="text" @click="$emit('cancel')">Cancel</v-btn>
        <v-spacer />
        <v-btn
          color="primary"
          :loading="loading"
          :disabled="disabled"
          @click="$emit('submit')"
        >
          {{ submitBtnText }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

import { DialogMixin } from '@/bundles/Dialogs/mixins/DialogMixin';

export default defineComponent({
  name: 'ConfirmationDialog',
  mixins: [DialogMixin],

  props: {
    title: {
      type: String,
      default: 'Please Confirm Your Action',
    },
    submitBtnText: {
      type: String,
      default: 'Confirm',
    },
    hideActions: Boolean,
    loading: Boolean,
    disabled: Boolean,
    maxWidth: {
      type: [String, Number],
      default: 600,
    },
  },

  emits: ['update:modelValue', 'cancel', 'submit'],

})
</script>
